import HardwareTable from './HardwareTable.vue';
export default HardwareTable;
